// extracted by mini-css-extract-plugin
module.exports = {"action":"x-FhLo","upgradeSuccess":"Wa07Y8"};